import '../../sass/layout/sections/pagination.scss';

(function(window, document, undefined){
    const breakpoints={
        320: {
            max: 5,
            start: 1,
            end: 1,
            dots: true
        },
        768: {
            max: 9,
            start: 2,
            end: 2,
            dots: true
        },
        1280: {
            max: 15,
            start: 5,
            end: 5,
            dots: true
        },
        1900: {
            max: 17,
            start: 5,
            end: 5,
            dots: true
        }
    };
    const pages=document.querySelectorAll('ul.pagination-number li.page-item');
    let activePageIndex;
    for(activePageIndex=0; activePageIndex<pages.length; activePageIndex++){
        if(pages[activePageIndex].classList.contains('active')){
            break;
        }
    }
    
    const pagination=()=>{
        const windowWidth=window.innerWidth;
        let breakpoint;
        for (const property in breakpoints) {
            if(windowWidth>=property)
                breakpoint=breakpoints[property];
        }
        
        const half=Math.floor((breakpoint.max - breakpoint.start - breakpoint.end) / 2);
        let p1, p2;
        if(activePageIndex - half>breakpoint.start && activePageIndex + half < pages.length - breakpoint.end){
            p1=activePageIndex - half;
            p2=activePageIndex + half;
        }
        else if(activePageIndex - half <= breakpoint.start){
            p1=breakpoint.start;
            p2=2 * half + breakpoint.start;
        }
        else{
            p1=pages.length - breakpoint.end - 2 * half - 1;
            p2=pages.length - breakpoint.end;
        }
        
        for(let i=0; i<pages.length; i++){
            if(pages.length<breakpoint.max)pages[i].classList.remove('disabled');
            else if(i<breakpoint.start)pages[i].classList.remove('disabled');
            else if(i>=pages.length-breakpoint.end)pages[i].classList.remove('disabled');
            else if(i>=p1 && i<=p2)pages[i].classList.remove('disabled');
            else pages[i].classList.add('disabled');
            
            if(breakpoint.dots==true && i==breakpoint.start - 1 && p1>breakpoint.start)pages[i].classList.add('page-dots');
            else if (breakpoint.dots==true && i==p2 && p2<pages.length - breakpoint.end)pages[i].classList.add('page-dots');
            else pages[i].classList.remove('page-dots');
        }
    };
    
    window.addEventListener("resize", () => {
        pagination();
    });

    
    pagination();
    
})(window, document);
